import {Block, BLOCKS, Document, Inline} from '@contentful/rich-text-types'

import {HtmlElementType} from '@/components/common/content/Text'

const HEADING_LEVELS: Partial<Record<string, number>> = {
  [BLOCKS.HEADING_1]: 1,
  [BLOCKS.HEADING_2]: 2,
  [BLOCKS.HEADING_3]: 3,
  [BLOCKS.HEADING_4]: 4,
  [BLOCKS.HEADING_5]: 5,
  [BLOCKS.HEADING_6]: 6,
}

// Editors pick a heading by its size, so a heading 4 can follow a heading 2. Screen readers need
// levels without gaps, so each heading gets at most one level deeper than the previous one, while
// keeping the look the editor chose. `previousLevel` is the heading just before the content (the
// page's h1)
export const withSequentialHeadingLevels = (document: Document, previousLevel = 1): Document => {
  let lastLevel = previousLevel
  return {
    ...document,
    content: document.content.map((node) => {
      const level = HEADING_LEVELS[node.nodeType]
      if (!level) {
        return node
      }
      const htmlLevel = Math.min(level, lastLevel + 1)
      lastLevel = htmlLevel
      return {...node, data: {...node.data, htmlLevel}}
    }),
  }
}

// The HTML element for a heading node, falling back to its own level outside a normalized document
export const getHeadingElement = (node: Block | Inline, fallbackLevel: number) =>
  `h${node.data.htmlLevel ?? fallbackLevel}` as HtmlElementType
